"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertNever = assertNever;
/**
 * Fails closed when a supposedly exhaustive branch receives a new or invalid
 * value. Passing the value as `never` makes TypeScript reject non-exhaustive
 * switches when their input union grows.
 */
function assertNever(value, context) {
    throw new Error(`${context}: ${String(value)}`);
}
